// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1daIU","right":"Footer_right__32hdo","buttons":"Footer_buttons__3bDqv"};